/**
* This code was copied from `/include/static/js/tableFilter.js` file
* and was slightly refactored
*/
import $ from 'jquery';
import filterHelper from './helper';
import {
  updateQueryParamFilter,
  areRedirectionParamsDefined,
  updateRedirectionUrls,
} from './query-filters';

const selectors = {
  filtersToggleButton: '.js-filter-button',
  enabledFilterInputs: `
    .form-widget--filter [name]:not(disabled),
    .js-table-widget-filter [name]:not(disabled)
  `,
  annualFeeFirst: 'input[name="cc_product_annual_fee_first"].js-input-range',
};

function attachFilters(tableFilters) {
  const $tableFilters = $(tableFilters);
  const $comparison = $tableFilters.parents('.js-comparison-calculator');
  const $table = $comparison.find('.js-calculator-table');

  function registerEventListeners() {
    $tableFilters.on('change reset submit', onResetFilterForm);

    $comparison.on('click touchstart', selectors.filtersToggleButton, onFilterToggle);

    $comparison.find(selectors.annualFeeFirst)
      .on('change', onAnnualFeeFirstChange);

    $comparison.find(selectors.enabledFilterInputs)
      .on('change', onFilterInputChange);
  }

  // Force a check of all filters on initial load. Required as filter values passed in via the URL would not have
  // prompted a redraw. Redraws otherwise only happen on filter value change.
  $tableFilters.map((i, filter) => onResetFilterForm(filter));

  /**
   * GA Tracking on Advanced Search button
   */
  function onFilterToggle({ currentTarget: button }) {
    const action = $tableFilters.data('filter');
    let label = 'Advanced Search ';
    label += $tableFilters.hasClass('active') ? 'Hide' : 'Show';

    $.trackEventComplete(action, label, '', true);
    toggleIcon(button);
  }

  /**
   * GA Tracking on Filters
   */
  function onFilterInputChange(event) {
    const $input = $(event.currentTarget);
    const action = $('.form-widget--filter').data('filter');
    const label = $input.data('track-label');
    let value = $input.val();

    if ($input.find('option').length > 0) {
      value = $input.find('option:selected').text();
    }

    if ($input.prop('checked')) {
      value = $input.data('track-value');
    }

    if (areRedirectionParamsDefined()) {
      updateQueryParamFilter(event, false);
    }

    $.trackEvent(action, label, value);
  }

  /**
   * Advanced Search Icon toggles plus & minus classes
   */
  function toggleIcon(button) {
    const $icon = $(button).find('i');
    const classNames = {
      plus: 'icon-plus',
      minus: 'icon-minus',
    };

    if ($icon.hasClass(classNames.plus)) {
      $icon
        .removeClass(classNames.plus)
        .addClass(classNames.minus);
    } else {
      $icon
        .removeClass(classNames.minus)
        .addClass(classNames.plus);
    }
  }

  /**
   * Hide `less than` if annual fee is $0 -  BT only
   */
  function onAnnualFeeFirstChange({ currentTarget }) {
    const $input = $(currentTarget);
    const $zeroOnly = $input.closest('.form__group').find('.js-zero-only');

    if ($input.val() === '0') {
      $zeroOnly.addClass('hide');
    } else {
      $zeroOnly.removeClass('hide');
    }
  }

  /**
   * If table modal is existing, reopen it on filter form reset
   * @param isEventReset
   */
  function openModalOnReset(isEventReset) {
    const $tableModal = $table.parent().siblings('.js-table-modal');
    if ($tableModal.length && isEventReset) {
      $tableModal.trigger('reopenTableModal');
    }
  }

  /**
   * Disable the form when a request is went out
   * Show spinner, Make table .7 opacity
   *
   * @param $filterForm
   * @param triggerEvent
   */
  function preFilterAjax(triggerEvent) {
    $table.trigger('onLoading');

    if (triggerEvent === 'change') {
      // Disable form to prevent double submission
      $tableFilters.find(':input').prop('disabled', true);
    }
  }

  function applyLazyLoadOnTable(table) {
    table.find('img[data-src]').each((i, img) => img.setAttribute('src', img.dataset.src));
  }

  /**
   * Enable the form when a request is went out
   * Hide spinner, Make table 1 opacity
   */
  function postFilterAjax(result, triggerEvent) {
    openModalOnReset(triggerEvent === 'reset');

    $table.trigger('onLoaded');
    // Re-enable form
    $tableFilters.find(':input').prop('disabled', false);
  }

  // When 'submitFilterForm' is triggered:
  // Hide reset message if it is showing
  // Send ajax request
  // If response is not empty, redraw table, update sorting plugin, check popover
  // If response is empty, hide table, show reset message
  // Call postFilter ajax function
  function submitFilterForm(data) {
    const $tableBody = $table.find('tbody');
    const $moreInfoCTA = $comparison.find('.js-more-info-temp__cta');
    const categoryId = $comparison.data('category');
    const site = $comparison.data('site');
    const $filterMessage = $tableFilters.find('.form-widget__message, .js-table-widget-message');
    const fieldset = $comparison.data('fieldset');
    const mobileTemplate = $comparison.data('mobile-template');
    const template = $table.data('template') || 'comparison';
    const executeCalculatorAjax = $comparison.data('autoRecalculate') !== 'false';
    const filters = data && data.event.type !== 'reset' ? filterHelper.getFormFilters($tableFilters) : [];
    const ajaxData = {
      action: 'redraw_table_ajax',
      category: categoryId,
      filters,
      site,
      template,
    };

    function onAjaxSuccessResponse(response) {
      const isTableBodyDefined = typeof response.html.table_body !== 'undefined';
      const result = response.html !== ''
        && (!isTableBodyDefined || (
          isTableBodyDefined && response.html.table_body !== ''
        ));

      if (result) {
        const tr = isTableBodyDefined ? response.html.table_body : response.html;

        // Replace Table content
        $tableBody
          .empty()
          .html(tr);

        $table.show();
        $table.find($('[rel="popover"]')).trigger('loadpopover');

        // Update Table for Sorting plugin
        $table.trigger('update');

        // Recalculate the Calculator's column
        if (executeCalculatorAjax) {
          window.finder.calculators.submitData($comparison);
        }

        // Replace content of table expander's hidden container
        if (response.html.more_info !== 'undefined') {
          $moreInfoCTA.html(response.html.more_info);
        }

        applyLazyLoadOnTable($table);

        if (data.goToElement === true) {
          window.gotoElemPos($table);
        }

        if (areRedirectionParamsDefined()) {
          updateRedirectionUrls();
        }

        if (mobileTemplate) {
          $(document).trigger('attach-title-expander');
        }
      } else {
        // Hide table and Show Warning Message
        $table.hide();
        $filterMessage.removeClass('hide');
        $filterMessage.show();

        if (data.goToElement === true) {
          window.gotoElemPos($filterMessage);
        }
      }
    }

    // Reset message box
    $filterMessage.hide();

    // Things to do BEFORE the Ajax is triggered
    preFilterAjax(data.event.type);

    // If 'More Info' Expander Temp Container is available
    if ($moreInfoCTA.length) {
      ajaxData.more_info = true;
    }

    if (fieldset) {
      ajaxData.fieldset = fieldset;
    }

    if (mobileTemplate) {
      ajaxData.mobile = mobileTemplate;
    }

    // Fallback
    if (typeof window.wpajax === 'undefined') {
      postFilterAjax();
      return;
    }

    $.get(window.wpajax.ajaxurl, ajaxData)
      .done(onAjaxSuccessResponse)
      // Things to do AFTER the Ajax is triggered
      .always(results => postFilterAjax(results, data.event.type));
  }

  // Trigger 'SubmitFilterForm' event with event type:change, reset or submit
  function onResetFilterForm(event) {
    const $filterButton = $tableFilters.find('.btn');

    // Auto-Submit the Filter form - except when the Submit button is present (small screen only)
    if ($filterButton.is(':visible')) {
      if (event.type === 'submit') {
        event.preventDefault();
        // Trigger the submission and focus the user on the table or error message on complete
        submitFilterForm({
          goToElement: true,
          event,
        });
      } else if (event.type === 'reset') {
        $tableFilters[0].reset();
        // Trigger the submission and focus the user on the table or error message on complete
        submitFilterForm({
          goToElement: true,
          event,
        });
      }
    } else {
      submitFilterForm({
        event,
      });
    }
  }

  registerEventListeners();
}

export default attachFilters;
